<template>
  <div class="container">
    <div class="top">
      <div class="title">{{ $t("routes.ntripUser") }}</div>
      <div class="flex">
        <el-select
          v-model="searchType"
          size="mini"
          @change="handleChange"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input :placeholder="placeholder" v-model="searchKey" size="mini" @keyup.enter.native="toSearch">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="toSearch"
          ></el-button>
        </el-input>
      </div>
    </div>
    <div class="table">
      <!-- :cell-style="{ padding: '5px' }" -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        ref="table"
        height="100%"
        :empty-text="emptyText"
      >
        <el-table-column
          v-for="(item, index) in column"
          show-overflow-tooltip
          :key="index"
          align="center"
          :prop="column[index].key"
          :label="$t(`public.${column[index].key}`)"
          :width="column.width"
        >
          <template slot-scope="scoped">
            <span v-if="column[index].key == 'time'">
            {{ scoped.row[item.key] ? diffTime(scoped.row[item.key]) : "" }}</span>
            <span v-else :style="{color: item.key == 'lon' || item.key == 'lat' || item.key == 'data' ? '#2D8CF0' : ''}">
              {{ scoped.row[item.key] }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" :label="'操作'">
          <template slot-scope="scoped">
            <el-button @click="operateEdit(scoped.row)"> 编辑 </el-button>
            <el-button @click="operateDel(scoped.row)"> 删除 </el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getUsers } from "@/api/index";
export default {
  name: "OverseasStationManageOnlineNtrip",

  data() {
    return {
      emptyText: this.$t("public.loading"),
      options: [
        {
          value: "0",
          label: this.$t("public.bsName"),
        },
        {
          value: "1",
          label: this.$t("public.sn"),
        },
      ],
      placeholder: this.$t("public.bsName"),
      searchType: "0",
      total: 0,
      pageSize: 10,
      page: 1,
      column: [
        { label: "机器码", key: "sn" },
        { label: "用户名", key: "name" },
        { label: "当前基站", key: "current" },
        { label: "绑定基站", key: "station" },
        { label: "距离", key: "distance" },
        { label: "连接时间", key: "time" },
        { label: "数据量", key: "data" },
        { label: "软件名称", key: "softName" },
        { label: "卫星数量", key: "num" },
        { label: "差分状态", key: "state" },
      ],
      searchKey: "",
      tableData: [],
      allData: [],
    };
  },

  activated() {
    this.getList();
  },
  deactivated() {
    this.page = 1;
  },

  methods: {
    diffTime(time) {
      let t = new Date(time);
      let temp = t.getTime() + this.getLocalTime();
      const dateObj = new Date(temp);
      // 格式化为年-月-日 时:分:秒字符串
      const formattedDateTime = `${dateObj.getFullYear()}-${String(
        dateObj.getMonth() + 1
      ).padStart(2, "0")}-${String(dateObj.getDate()).padStart(
        2,
        "0"
      )} ${String(dateObj.getHours()).padStart(2, "0")}:${String(
        dateObj.getMinutes()
      ).padStart(2, "0")}:${String(dateObj.getSeconds()).padStart(2, "0")}`;
      return formattedDateTime;
    },
    // 返回当地时间和北京时间的时间戳差值
    getLocalTime() {
      let d = new Date();
      //算得时区
      var time_zone = -d.getTimezoneOffset() / 60;
      if (time_zone < 0) {
        time_zone = -(Math.abs(time_zone) + 8);
      } else {
        time_zone -= 8;
      }
      return time_zone * 60 * 60 * 1000;
    },
    handleSizeChange() {
      this.paging()
    },
    handleCurrentChange() {
      this.paging()
    },
    paging() {
      // 起始位置 = (当前页 - 1) x 每页的大小
      const start = (this.page - 1) * this.pageSize;
      // 结束位置 = 当前页 x 每页的大小
      const end = this.page * this.pageSize;
      this.tableData = this.allData.slice(start, end);
    },
    getList() {
      let param = {
        searchField: this.searchKey,
        searchType: this.searchType,
      };
      getUsers(param).then((res) => {
        if(!res.data || !res.data.length || res.data.length == 0){
          this.emptyText = this.$t("public.noData")
        } 
        this.allData = res.data.map((item, index) => {
          return {
            id: item.id,
            sn: item.sn,
            name: item.us,
            current: item.bn,
            station: item.bs,
            distance: (item.ds2 / 1000).toFixed(2) + 'km',
            time: item.st,
            data: (item.dn / 1024 / 1024).toFixed(2) + 'MB',
            softName: item.ua,
            num: item.sv,
            state: item.ds,
          };
        });
        this.total = this.allData.length;
        this.paging();
      });
    },
    handleChange(e) {
      // 基站名称0 机器码1
      // console.log(e,this.options[e-1], "eee")
      this.placeholder = this.options[e].label;
      // this.searchType
    },
    toSearch() {
      // console.log(this.searchType, this.searchKey)
      this.allData = []
      this.tableData = []
      this.page = 1
      this.getList()
    },
    // operateEdit(row) {

    // },
    // operateDel(row) {

    // },
  },
};
</script>
<style lang="scss" scoped>
.top {
  display: flex;
  align-content: center;
  justify-content: space-between;
}
.table {
  height: calc(100% - 30px - 32px - 28px);
  margin-top: 20px;
}
.pagination {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
::v-deep {
  .table th.el-table__cell {
    background-color: #3e916a;
    color: #fff;
    border: none;
  }
}
</style>